import { useCallback, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import api, { authHeaders } from "../services/api";

export default function useCurrentUsuario(enabled = true) {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const carregarUsuario = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!enabled || !token) {
      setUsuario(null);
      return null;
    }

    try {
      setLoading(true);
      setError("");

      const dadosToken = jwtDecode(token);

      if (!dadosToken?.idUsuario) {
        setUsuario(null);
        return null;
      }

      const resposta = await api.get(`/usuario/${dadosToken.idUsuario}`, {
        headers: authHeaders(token),
      });

      setUsuario(resposta.data);
      return resposta.data;
    } catch (erro) {
      setError("Nao foi possivel carregar a subscricao.");
      setUsuario(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    carregarUsuario();
  }, [carregarUsuario]);

  return {
    usuario,
    loading,
    error,
    refresh: carregarUsuario,
  };
}
